import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import GestionUsuario from './GestionUsuario';
import { useAccesos } from '../contexts/AccesosContext';
function Usuarios() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [usuarios, setUsuarios] = useState([]);
    const [editUsuario, setEditUsuario] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [usuarioToDelete, setUsuarioToDelete] = useState(null);


    const fetchUsuarios = async () => {
        try {
            const response = await fetch(`${server}/MgUsuarios`);
            const data = await response.json();
            setUsuarios(data.$values);

        } catch (error) {
            console.error('Error al cargar los usuarios:', error);
        }
    };

    useEffect(() => {

        


        fetchUsuarios();
    }, []);

    

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (usuario) => {
        setUsuarioToDelete(usuario);
        setDeleteDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDeleteDialogOpen(false);
        setUsuarioToDelete(null);
    };
    const handleNewUsuario = () => {
        fetchUsuarios();
        setEditUsuario(null);
    };
    const handleDeleteUsuario = async () => {
        if (usuarioToDelete) {
            try {
                const response = await fetch(`${server}/MgUsuarios/${usuarioToDelete.codigoUsuario}`, { method: 'DELETE' });
                if (response.ok) {
                    handleCloseDialog();
                    alert('Usuario eliminado con éxito');
                } else {
                    alert('Error al eliminar el usuario1');
                }
            } catch (error) {
                console.error('Error al eliminar el usuario:', error);
                alert('Error al eliminar el usuario');
            }
        }
    };

    const filteredUsuarios = usuarios.filter(usuario => 
        usuario.codigoUsuario?.toLowerCase().includes(searchQuery.toLowerCase()) || 
        usuario.nombreCompleto?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    {/* <div className="row"> */}
                        {/* <div className="col-md-8 col-sm-6 offset-md-2"> */}
                            <GestionUsuario onNewUsuario={handleNewUsuario} editUsuario={editUsuario} />
                        {/* </div> */}
                    {/* </div> */}
                    <br />
                    <h2>Usuarios Existentes</h2>
                    {/* <div className="row"> */}
                        {/* <div className="col-md-8 col-sm-6 offset-md-2"> */}
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Buscar usuario"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{ marginBottom: '20px' }}
                            />
                            <div className="table-responsive">
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Código Usuario</TableCell>
                                                <TableCell>Nombre Completo</TableCell>
                                                <TableCell>Empresa</TableCell>
                                                <TableCell>Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredUsuarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((usuario) => (
                                                <TableRow key={usuario.codigoUsuario}>
                                                    <TableCell>{usuario.codigoUsuario}</TableCell>
                                                    <TableCell>{usuario.nombreCompleto}</TableCell>
                                                    <TableCell>{usuario.nombreEmpresa}</TableCell>
                                                    <TableCell>
                                                        <Button onClick={() => setEditUsuario(usuario)} color="primary" disabled={!tienePermiso('Editar Usuario')}>Editar</Button>
                                                        <Button onClick={() => handleOpenDialog(usuario)} color="secondary" disabled={!tienePermiso('Eliminar Usuario')}>Eliminar</Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={filteredUsuarios.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                                <Dialog
                                    open={deleteDialogOpen}
                                    onClose={handleCloseDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle>{"Confirmar eliminación"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            ¿Estás seguro de que deseas eliminar este usuario?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                        <Button onClick={handleDeleteUsuario} color="primary" autoFocus>Eliminar</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default Usuarios;
